import React from 'react';
import { ChartLine } from '@p81-common/ui';
import PropTypes, { object } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { options, tooltipColors } from './config';
import { featuresFormater } from 'utils/featuresFormater';

import '../helpers/fix.css';

const ChartHS = ({ chartData = [] }) => {
  const { t } = useTranslation(['activity']);

  const chartConfig = [];
  if (chartData.length > 0) {
    // get feature ids (except the 'date' field)
    const featureIds = Object.keys(chartData[0]).slice(1);
    featureIds.forEach(featureId => {
      chartConfig.push({
        name: featuresFormater(featureId, t),
        id: featureId,
        show: true,
        color: '#2a5dca'
      });
    });
  }

  const getTooltipColor = value => {
    if (value <= 25) return tooltipColors.red;
    if (value > 25 && value <= 50) return tooltipColors.yellow;
    if (value > 50 && value <= 75) return tooltipColors.lgreen;
    if (value > 75) return tooltipColors.green;
  };

  const tooltipFormatter = item => {
    const color = getTooltipColor(item.value);
    return { ...item, color };
  };

  return (
    <ChartLine
      data={chartData}
      chartConfig={chartConfig}
      tooltipFormatter={tooltipFormatter}
      {...options}
    />
  );
};

ChartHS.propTypes = {
  chartData: PropTypes.arrayOf(object),
  show: PropTypes.bool
};

export default ChartHS;
